// Calculate height units
// ----------------------------------------

// More info: https://www.npmjs.com/package/vh-check

const VH = vhCheck();
//console.log(VH);
